export default __webpack_public_path__ + "static/media/lb-m-banner-cn.54b0d590.webp";